export const ReasignTableHelpers = {
    data() {
        return {
            tableColumns: [{
                title: this.$t('Expediente'),
                type: 'custom-html',
                key: 'record',
                modifier: (item, row) => {
                    if (row?.status?.id == 145 || row?.status?.id == 142) {
                        return `<a href="/accreditations/applications/${row.id}" target="_blank">${item || ''}</a>`;
                    } else {
                        return item;
                    }
                }
            },
            {
                title: 'OEC',
                type: 'custom-html',
                key: 'organization',
                modifier: (value) => {
                    if (value) {
                        return value.business_name;
                    } else {
                        return "";
                    }
                    
                }
            },
            {
                title: this.$t('Tipo'),
                type: 'custom-html',
                key: 'accreditation_type',
                modifier: (value) => {
                    return value.name;
                }

            },

            {
                title: this.$t('Actividad'),
                type: 'custom-html',
                key: 'accreditation_activity',
                modifier: (value) => {
                    return value.name;
                }

            },

            {
                title: this.$t('Técnico'),
                type: 'custom-html',
                key: 'technical',
                modifier: (value) => {
                    if (value) {
                        return value.full_name;
                    }
                }
            },

            {
                title: 'Estado',
                type: 'custom-html',
                key: 'status',
                isVisible: true,
                modifier: (value) => {
                    return value.name;

                }
            },
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}